import { render, staticRenderFns } from "./BookInfoDialog.vue?vue&type=template&id=89e14e1e&scoped=true"
import script from "./BookInfoDialog.vue?vue&type=script&lang=js"
export * from "./BookInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e14e1e",
  null
  
)

export default component.exports